export default __webpack_public_path__ + "static/media/ic_tlp_96.946bf1ee.svg";